import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const SectionNavigation = () => {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash && ['/', '/about', '/services'].includes(pathname)) {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
      return;
    }
    if (pathname !== '/' || !['#why', '#gallery'].includes(hash)) return;

    let cancelled = false;
    let frame;
    // Wait for the destination route, collapsed mobile menu, and font metrics.
    document.fonts.ready.then(() => {
      if (cancelled) return;
      frame = window.requestAnimationFrame(() => {
        if (cancelled) return;
        const target = document.getElementById(hash.slice(1));
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target?.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
      });
    });
    return () => {
      cancelled = true;
      window.cancelAnimationFrame(frame);
    };
  }, [pathname, hash, key]);

  return null;
};